/* eslint-disable radix */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FontSelect from '../../componentLibrary/FontSelect';
import * as columnItemActions from '../../actions/columnItem';
import { getLineHeight, getLineHeightMultiplier } from './LineHeight';
import Alignment from './Alignment';
import * as Styled from './styles';
import { blockType } from '../../types';

class Toolbar extends Component {
    state = {
        blockIndex: null,
        columnIdx: null,
        elmIdx: null,
        content: null,
        contentValues: {
            textMarkupValue: '',
            align: '',
            fontFamily: '',
            fontID: null,
            fontSize: '',
            lineHeight: '',
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            paddingLeft: 0,
        },
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { canvasBlocks, selectedElements } = nextProps;
        if (Object.keys(selectedElements).length <= 0) {
            return {
                ...prevState,
            };
        }
        // Updating elements requires information about the element which needs to get extracted from the canvas Blocks.
        const elmIdx = Object.keys(selectedElements)[0];
        const data = selectedElements[Object.keys(selectedElements)[0]];
        const { blockIndex, columnIdx } = data;
        const blockContainingElement = canvasBlocks.find((block) => block.index === blockIndex);
        const columnContainingElement =
            blockContainingElement &&
            Object.keys(blockContainingElement).length > 0 &&
            blockContainingElement.content.columns.find((column) => column.columnIdx === columnIdx);
        const selectedElement =
            columnContainingElement &&
            Object.keys(columnContainingElement).length > 0 &&
            columnContainingElement.columnItems.find((elm) => elm.elmIdx === elmIdx);
        const { content } = selectedElement;
        const { textMarkupValue, align, fontFamily, fontID, fontSize, lineHeight } = content;
        const contentValues = { textMarkupValue, align, fontFamily, fontID, fontSize, lineHeight };
        // Local state needs to get updated with the actual content value of the selected element
        return {
            ...prevState,
            elmIdx,
            blockIndex,
            columnIdx,
            content,
            contentValues,
        };
    }

    // This function update the local state and the store with the new setting values of the element selected element
    _updateContent(key, value) {
        const { blockIndex, columnIdx, elmIdx, content, contentValues } = this.state;
        const { dispatch } = this.props;

        let newContentValues;
        if (key === 'fontSize') {
            const { fontSize, lineHeight } = contentValues;
            const lineHeightMultiplier = getLineHeightMultiplier(fontSize, lineHeight);

            // we need to make sure the line height is updated using the multiplier so we keep the same proportion
            newContentValues = {
                ...contentValues,
                [key]: value,
                lineHeight: getLineHeight(value, lineHeightMultiplier),
            };
        } else if (key === 'fontFamily') {
            const { fontID, value: fontValue } = value;
            newContentValues = { ...contentValues, [key]: fontValue.trim(), fontID };
        } else {
            newContentValues = { ...contentValues, [key]: value };
        }

        const newContent = { ...content, ...newContentValues };
        dispatch(columnItemActions.updateColumnItemContent({ blockIndex, columnIdx, elmIdx, newContent }));
        this.setState((prevState) => ({
            ...prevState,
            contentValues: newContentValues,
        }));
    }

    render() {
        const { contentValues } = this.state;
        const { leftPanelCollapsed } = this.props;
        const { fontSize, lineHeight, fontFamily, fontID, align } = contentValues;
        const currLineHeight = String(
            parseFloat(lineHeight.split('px')[0] / fontSize.split('px')[0]).toFixed(1)
        ).replace(/.0/g, '');
        return (
            <Styled.ToolbarDiv leftPanelCollapsed={leftPanelCollapsed}>
                <FontSelect
                    width={158}
                    type="fontFamily"
                    label="Font Family"
                    value={fontFamily}
                    fontID={fontID}
                    styling={{
                        marginTop: 41,
                        height: 26,
                        border: 'none',
                        borderLeft: '1px solid #D9DADB',
                        marginRight: 2,
                        paddingTop: 2,
                    }}
                    onChange={(selectedOption) => {
                        const selectedFontFamilyValue = selectedOption.value.trim();
                        if (selectedFontFamilyValue === fontFamily) {
                            return;
                        }

                        this._updateContent('fontFamily', selectedOption);
                    }}
                />
                <FontSelect
                    width={78}
                    type="fontSize"
                    label="Font Size"
                    value={fontSize}
                    styling={{ marginTop: 42, border: 'none', borderLeft: '1px solid #D9DADB', paddingLeft: 3 }}
                    marginBottom={3}
                    onChange={(selectedOption) => {
                        const selectedFontSize = selectedOption.value.trim();
                        if (selectedFontSize === fontSize) {
                            return;
                        }

                        this._updateContent('fontSize', selectedFontSize);
                    }}
                />
                <Styled.RightToolbarDiv>
                    <Styled.LeftButtons>
                        <Alignment
                            updateAlignment={(alignment, direction) => this._updateContent(alignment, direction)}
                            currentAlignment={align}
                        />
                        <FontSelect
                            width={82}
                            type="lineHeight"
                            label="Line Height"
                            icon="format_line_spacing"
                            value={currLineHeight}
                            styling={{
                                color: '#4B4B4B',
                                marginTop: 9,
                                height: 28,
                                zIndex: 5,
                                border: 'none',
                                borderLeft: '1px solid #D9DADB',
                                paddingLeft: 10,
                            }}
                            onChange={(selectedOption) => {
                                const selectedLineHeight = selectedOption.value.trim();
                                if (selectedLineHeight === currLineHeight) {
                                    return;
                                }
                                const newLineHeight = `${parseInt(
                                    parseFloat(selectedLineHeight) * parseInt(fontSize.split('px')[0])
                                )}px`;

                                this._updateContent('lineHeight', newLineHeight);
                            }}
                        />
                    </Styled.LeftButtons>
                </Styled.RightToolbarDiv>
            </Styled.ToolbarDiv>
        );
    }
}
Toolbar.propTypes = {
    dispatch: PropTypes.func.isRequired,
    leftPanelCollapsed: PropTypes.bool.isRequired,
    canvasBlocks: PropTypes.arrayOf(blockType).isRequired,
    selectedElements: PropTypes.shape({
        local: PropTypes.object,
        remote: PropTypes.object,
    }).isRequired,
};

const mapStateToProps = (state) => ({
    canvasBlocks: state.canvasBlocks.present,
    selectedElements: state.selectedElements.local,
});

export default connect(mapStateToProps)(Toolbar);
